<template>
    <div   class="rounded-md p-4 h-full">
        <div    v-if="!loading"
                class="h-full flex flex-col justify-around items-start">
            <div class="flex items-center py-1">
                <div class="shrink-0">
                    <!-- Heroicon name: exclamation -->
                    <svg    v-if="snapshotIssues > 0"
                            class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                            fill="currentColor">
                        <path fill-rule="evenodd"
                              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                              clip-rule="evenodd"/>
                    </svg>
                    <svg    v-else
                            class="shrink-0 mr-1.5 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                </div>
                <a      :href="snapshotLink"
                        class="cursor-pointer plain-link text-left text-base ml-2 leading-5 font-medium text-yellow-800 inline-block">
                    {{ snapshotIssues }} issue<span v-if="snapshotIssues !== 1">s</span> found
                </a>
            </div>
            <div    v-if="longAlarmIssues > 0"
                    class="flex items-center py-1">
                <div
                        class="shrink-0">
                    <!-- Heroicon name: exclamation -->
                    <svg    class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                            fill="currentColor">
                        <path fill-rule="evenodd"
                              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
                <a      :href="alarmsLink"
                        class="cursor-pointer plain-link text-left text-base ml-2 leading-5 font-medium text-red-800 inline-block">
                    {{ longAlarmIssues }} long-lived alarm<span v-if="longAlarmIssues !== 1">s</span> found
                </a>
            </div>
            <div class="flex items-center py-1">
                <div class="shrink-0">
                    <!-- Heroicon name: exclamation -->
                    <svg    v-if="! snapEnrolled"
                            class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                            fill="currentColor">
                        <path fill-rule="evenodd"
                              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                              clip-rule="evenodd"/>
                    </svg>
                    <svg    v-else
                            class="shrink-0 mr-1.5 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                </div>
                <span v-if="snapEnrolled" class="text-left text-base ml-2 leading-5 font-medium text-gray-600 inline-block">SNAP enrolled</span>
                <span v-else class="text-left text-base ml-2 leading-5 font-medium text-gray-600 inline-block">Not SNAP enrolled</span>
            </div>
        </div>
        <div    v-else>
            Loading
        </div>
    </div>
</template>

<script>

export default {
    name: "SnapshotIssues",
    mixins: [],
    props: {
        company: String,
        issues: Object,
        snapEnrolled: Boolean,
    },
    data() {
        return {
            loading: false,
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {

    },
    computed: {
        snapshotIssues() {
            return this.issues.issuesCount
        },
        longAlarmIssues() {
            return this.issues.longAlarmsCount
        },
        snapshotLink() {
            return `/${this.company}/snapshot`
        },
        alarmsLink(){
            return `/${this.company}/alarms`
        }
    },
    beforeUnmount() {
    },
}

</script>

